// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToSmall":"(max-width: 374px)","colorFS-50":"#3E3AC2","signupCTA":"G4ea720","signupCTAInnerContainer":"G16c33b"};